module.exports = __webpack_public_path__ + "img/14.82ba21f8.jpg";